import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-corporate-offshore-planning',
  templateUrl: './corporate-offshore-planning.component.html',
  styleUrls: ['./corporate-offshore-planning.component.scss']
})
export class CorporateOffshorePlanningComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
